import React from "react";
import { Link, NavLink } from "react-router-dom";
import classes from "./Navbar.module.css";
import { useSelector, useDispatch } from "react-redux";
import { loginActions } from "../../Store/login";
import logo from "../../Assets/logo.webp";
import mobileLogo from "../../Assets/logo_mobile.png";

const Navbar = () => {
  const loggedIn = useSelector((state) => state.loggedIn.loggedIn);
  // const emailVerified = useSelector((state) => state.loggedIn.userVerification);

  const dispatch = useDispatch();
  const logoutHandler = () => {
    dispatch(loginActions.loggedOut());
  };
  return (
    <div className={classes.nav}>
      <Link to="/">
        <div className={classes.logo}>
          <img className={classes.logo1} src={logo} alt="Website Logo" />
          <img className={classes.logo2} src={mobileLogo} alt="Website Logo" />
        </div>
      </Link>
      <div className={classes.items}>
        <ul>
          {/* <li>
            <NavLink
              className={(navigationData) =>
                navigationData.isActive ? classes.active : null
              }
              to="/courier"
            >
              Become a Courier
            </NavLink>
          </li> */}
          <li>
            <NavLink
              className={(navigationData) =>
                navigationData.isActive ? classes.active : null
              }
              to="/contact"
            >
              Contact Us
            </NavLink>
          </li>
          <li>
            <NavLink
              className={(navigationData) =>
                navigationData.isActive ? classes.active : null
              }
              to="/order"
            >
              Order Now!
            </NavLink>
          </li>
          {!loggedIn && (
            <li>
              <NavLink
                className={(navigationData) =>
                  navigationData.isActive ? classes.active : null
                }
                to="/login"
              >
                Login/Signup
              </NavLink>
            </li>
          )}
          {loggedIn && (
            <li>
              <NavLink
                className={(navigationData) =>
                  navigationData.isActive ? classes.active : null
                }
                to="/history"
              >
                History
              </NavLink>
            </li>
          )}
          {loggedIn && (
            <button onClick={logoutHandler} className={classes.logout}>
              Logout
            </button>
          )}{" "}
        </ul>
      </div>
    </div>
  );
};

export default Navbar;
